import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabsPage } from './tabs.page';

const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'home',
        loadChildren: () => import('../home/tab1.module').then(m => m.Tab1PageModule),
      },
      {
        path: 'weighins',
        loadChildren: () => import('../pages/driverweighins/driverweighins.module').then(m => m.DriverweighinsPageModule),
      },
      {
        path: 'nyheder',
        loadChildren: () => import('../nyheder/nyheder.module').then(m => m.NyhederPageModule)
      },
      
      {
        path: 'skimmelvarsling',
        loadChildren: () => import('../skimmelvarsling/skimmelvarsling.module').then(m => m.SkimmelvarslingPageModule)
      },
      {
        path: 'sortsinfo',
        loadChildren: () => import('../sortsinfo/sortsinfo.module').then(m => m.SortsinfoPageModule)
        //loadChildren: () => import('../pages/login/login.module').then(m => m.LoginPageModule)
      },
      {
        path: 'danskkartoffelstivelse',
        loadChildren: () => import('../dansk-kartoffelstivelse/danskkartoffelstivelse.module').then(m => m.DanskkartoffelstivelsePageModule)
        //loadChildren: () => import('../pages/login/login.module').then(m => m.LoginPageModule)
      }
      
      /*,
      {
        path: '',
        redirectTo: '/asb/home',
        pathMatch: 'full'
      }*/
    ]
  }
  /*,
  {
    path: '/',
    redirectTo: 'skimmelvarsling',
    pathMatch: 'full'
  }
  ,
  {
    path: '',
    redirectTo: '/asb/home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    redirectTo: '/login',
    pathMatch: 'full'
  }*/
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class TabsPageRoutingModule {}
